import { render } from "./CodeScreen.vue?vue&type=template&id=7a7281ae&scoped=true&lang=html"
import script from "./CodeScreen.vue?vue&type=script&lang=js"
export * from "./CodeScreen.vue?vue&type=script&lang=js"

import "./CodeScreen.vue?vue&type=style&index=0&id=7a7281ae&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/scania_guess_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7281ae"]])

export default __exports__